import React, { useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";
import { Alert } from "@mapmycustomers/ui";

import { getActivityTypes } from "@app/store/activity";
import { RootState } from "@app/store/rootReducer";

import { isActivityTypeWarningDismissed } from "../../store";
import { dismissActivityTypePreviewWarning } from "../../store/actions";

import styles from "./ActivityTypeWarning.module.scss";

interface Props {
  activityTypes: ActivityType[];
  defaultActivityTypeId: ActivityType["id"];
  dismissPreviewWarning: typeof dismissActivityTypePreviewWarning;
  isWarningDismissed: boolean;
}

const ActivityTypeWarning: React.FC<Props> = ({
  activityTypes,
  defaultActivityTypeId,
  dismissPreviewWarning,
  isWarningDismissed,
}) => {
  const intl = useIntl();

  const handleWarningClose = useCallback(() => {
    dismissPreviewWarning();
  }, [dismissPreviewWarning]);

  return !isWarningDismissed ? (
    <Alert
      className={styles.defaultValueWarning}
      closable
      message={intl.formatMessage(
        {
          id: "createEditActivityModal.form.preview.defaultType.warning",
          defaultMessage:
            "This preview is showing the layout for “{value}” because it is set as the default activity type on the main layout. Switch to any activity type that does not have a variant to see the default form.",
          description: "Alert about default value in create activity modals in preview mode",
        },
        {
          value: activityTypes.find((type) => type.id === defaultActivityTypeId)?.name,
        }
      )}
      onClose={handleWarningClose}
      showIcon
      type="warning"
    />
  ) : null;
};

const mapStateToProps = (state: RootState) => ({
  activityTypes: getActivityTypes(state),
  isWarningDismissed: isActivityTypeWarningDismissed(state),
});

const mapDispatchToProps = {
  dismissPreviewWarning: dismissActivityTypePreviewWarning,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityTypeWarning);
